import React from 'react';
import { motion } from 'framer-motion';
import { UtensilsIcon, ShoppingCartIcon, HardHatIcon, StethoscopeIcon, BriefcaseIcon, FactoryIcon, CarIcon, HomeIcon, MonitorIcon, ScissorsIcon } from 'lucide-react';
export function BusinessTypesGrid() {
  const businesses = [{
    icon: UtensilsIcon,
    name: 'Restaurants'
  }, {
    icon: ShoppingCartIcon,
    name: 'Retail Stores'
  }, {
    icon: HardHatIcon,
    name: 'Construction'
  }, {
    icon: StethoscopeIcon,
    name: 'Medical'
  }, {
    icon: BriefcaseIcon,
    name: 'Professional'
  }, {
    icon: FactoryIcon,
    name: 'Manufacturing'
  }, {
    icon: CarIcon,
    name: 'Automotive'
  }, {
    icon: HomeIcon,
    name: 'Real Estate'
  }, {
    icon: ShoppingCartIcon,
    name: 'E-commerce'
  }, {
    icon: MonitorIcon,
    name: 'Technology'
  }, {
    icon: ScissorsIcon,
    name: 'Salons & Spas'
  }, {
    icon: BriefcaseIcon,
    name: 'Franchises'
  }];
  return <section className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden bg-black" data-id="element-49">
      <div className="max-w-7xl mx-auto" data-id="element-50">
        <div className="text-center mb-12" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-52">
            Trusted By Businesses Nationwide
          </h2>
          <p className="text-xl text-zinc-400" data-id="element-53">
            We fund almost every industry type
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4" data-id="element-54">
          {businesses.map((biz, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.05
        }} whileHover={{
          y: -5,
          boxShadow: '0 10px 25px -5px rgba(255, 255, 255, 0.1)'
        }} className="bg-zinc-900/50 p-6 rounded-xl text-center hover:bg-zinc-900 border border-zinc-800 transition-all cursor-default backdrop-blur-sm" data-id="element-55">
              <biz.icon className="w-8 h-8 text-white mx-auto mb-3" data-id="element-56" />
              <div className="font-medium text-zinc-300 text-sm" data-id="element-57">
                {biz.name}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}